import globalComponents from "./globalComponents";
import globalDirectives from "./globalDirectives.js";
import Vue2TouchEvents from 'vue2-touch-events';


export default {
  install(Vue) {
    Vue.use(globalComponents);
    Vue.use(globalDirectives);
	Vue.use(Vue2TouchEvents, {
	    disableClick: false,
	    touchClass: '',
	    tapTolerance: 10,
	    touchHoldTolerance: 400,
	    swipeTolerance: 30,
	    longTapTimeInterval: 400
	})
  }
};